import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { IonicModule, ModalController, Platform } from '@ionic/angular';
import { SolInputComponent } from '../common/components/forms/sol-input/sol-input.component';
import Swiper from 'swiper';
import { TranslateModule } from '@ngx-translate/core';
import { ActivationService } from '../common/services/activation.service';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
import { INPUT_TYPE } from '../common/components/forms/sol-input/sol-input.enums';


@Component({
    selector: 'sol-activation',
    templateUrl: './activation.component.html',
    styleUrl: './activation.component.scss',
    standalone: true,
    imports: [
        IonicModule,
        ReactiveFormsModule,
        SolInputComponent,
        TranslateModule,
        LottieComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class ActivationComponent implements AfterViewInit {
    @Input() data: { cardID: string } | undefined;
    @ViewChild('swiper', { static: false }) swiperElRef!: ElementRef<HTMLElement>;
    @ViewChild('videoEl', { static: true }) videoEl!: ElementRef<HTMLVideoElement>;
    /** slide atual */
    currentSlide = 0;
    /** representa status de ativacao */
    activating: boolean = false;
    isPinValid: boolean | undefined;
    /** lottie animation */
    animationOptions: AnimationOptions = {
        path: '../../assets/images/ok.json',
    };
    TYPE_OF_INPUT = INPUT_TYPE;
    private platform = inject(Platform);
    private activationService = inject(ActivationService);
    private modalCtrl = inject(ModalController);

    private matchEmails: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const group = control as FormGroup;
        const email = group.get('email')?.value;
        const confirmEmail = group.get('confirmEmail')?.value;
        return email === confirmEmail ? null : { emailsDoNotMatch: true };
    }

    activationForm = new FormGroup({
        name: new FormControl(null, [Validators.required]),
        email: new FormControl(null, [Validators.email, Validators.required]),
        confirmEmail: new FormControl(null, [Validators.email, Validators.required]),
        pin: new FormControl(null, [Validators.required, Validators.pattern(/^\d{4}$/)]),
        password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
        confirmPassword: new FormControl(null, [Validators.required]),
    }, { validators: [this.matchEmails] })

    ngAfterViewInit(): void {
      const swiperRef = (this.swiperElRef.nativeElement as any).swiper as Swiper;
      swiperRef.allowTouchMove = false;
      const video = this.videoEl.nativeElement;
      if (video) {
        video.muted = true;
        video.play().catch(error => console.warn('Autoplay prevented:', error));
      }
    }

    animationCreated(animationItem: AnimationItem): void {
        console.log(animationItem);
    }

    async slideNavigation(forwardDirection = true, activate = false) {
        if (activate) {
            await this.onActivateCard();
            return;
        }
        if (this.currentSlide === 0) {
            this.activationService.expandModal.next(true);
        }
        const swiperEl = this.swiperElRef.nativeElement;
        const swiper = (swiperEl as any).swiper as Swiper;
        forwardDirection ? swiper.slideNext() : swiper.slidePrev();
        this.currentSlide = (swiperEl as any).swiper.activeIndex;
    }

    async dismiss() {
        const m = await this.modalCtrl.getTop();
        await m?.dismiss();
    }

    private async onActivateCard() {
        this.activating = true;
        this.activationForm.disable();
        const data = this.activationForm.value as any;
        data.cardID = this.data?.cardID;
        /** objeto com o nome do usuario separado em primeiro e ultimo nome */
        const nameOfUsersObj = this.activationService.sortUserName(data.name);
        delete data.name;
        data.firstName = nameOfUsersObj.firstName;
        data.lastName = nameOfUsersObj.lastName;
        data.pin = Number(data.pin);
        const result = await this.activationService.activateCard(data);
        if (result.data.code === 'invalid-argument') {
            this.isPinValid = false;
            const swiperEl = this.swiperElRef.nativeElement;
            const swiper = (swiperEl as any).swiper as Swiper;
            swiper.slideTo(4);
            this.activationForm.enable();
        }
        if (result.data.status === 200) {
            this.slideNavigation();
        }
        this.activating = false;
    }
}
